// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 20px;
  height: 60px;
  min-height: 60px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* User Menu Trigger */
.user-menu-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px 6px 12px;
  background: #f5f5f5;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.user-menu-trigger:hover {
  background: #e8e8e8;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #9e9e9e;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  flex-shrink: 0;
}

.user-email {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.user-menu-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.user-menu-trigger:hover .user-menu-icon {
  background: #c82333;
  transform: scale(1.05);
}

/* Notifications */
.notification-icon {
  position: relative;
  cursor: pointer;
  padding: 8px;
  transition: background 0.3s ease;
  border-radius: 50%;
}

.notification-icon:hover {
  background: #f5f5f5;
}

.notification-icon i {
  font-size: 20px;
  color: #666;
}

.notification-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #dc3545;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 5px;
  border-radius: 10px;
  min-width: 16px;
  text-align: center;
}

/* User Menu */
.user-menu-container {
  position: relative;
}

.user-menu-dropdown {
  position: absolute;
  top: 45px;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  padding: 8px 0;
  z-index: 1000;
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.2s ease;
  color: #333;
  font-size: 14px;
}

.user-menu-item:hover {
  background: #f5f5f5;
}

.user-menu-item i {
  width: 20px;
  text-align: center;
  color: #666;
}

.user-menu-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 8px 0;
}

.user-menu-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px;
  color: #999;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.user-menu-section-title i {
  width: 20px;
  text-align: center;
  color: #999;
}

.language-item i {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.language-item.active {
  background: #f0f8ff;
  color: #028661;
  font-weight: 500;
}

.language-item.active i {
  opacity: 1;
  color: #028661;
}

/* Responsive */
@media (max-width: 768px) {
  .user-email {
    display: none;
  }

  .header-right {
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".app-header {\n  background: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 0 20px;\n  height: 60px;\n  min-height: 60px;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  z-index: 999;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.header-content {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.header-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* User Menu Trigger */\n.user-menu-trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 8px 6px 12px;\n  background: #f5f5f5;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.user-menu-trigger:hover {\n  background: #e8e8e8;\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #9e9e9e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.user-email {\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n}\n\n.user-menu-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #dc3545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 20px;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.user-menu-trigger:hover .user-menu-icon {\n  background: #c82333;\n  transform: scale(1.05);\n}\n\n/* Notifications */\n.notification-icon {\n  position: relative;\n  cursor: pointer;\n  padding: 8px;\n  transition: background 0.3s ease;\n  border-radius: 50%;\n}\n\n.notification-icon:hover {\n  background: #f5f5f5;\n}\n\n.notification-icon i {\n  font-size: 20px;\n  color: #666;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: #dc3545;\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  padding: 2px 5px;\n  border-radius: 10px;\n  min-width: 16px;\n  text-align: center;\n}\n\n/* User Menu */\n.user-menu-container {\n  position: relative;\n}\n\n.user-menu-dropdown {\n  position: absolute;\n  top: 45px;\n  right: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 200px;\n  padding: 8px 0;\n  z-index: 1000;\n}\n\n.user-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  color: #333;\n  font-size: 14px;\n}\n\n.user-menu-item:hover {\n  background: #f5f5f5;\n}\n\n.user-menu-item i {\n  width: 20px;\n  text-align: center;\n  color: #666;\n}\n\n.user-menu-divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 8px 0;\n}\n\n.user-menu-section-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 20px;\n  color: #999;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.user-menu-section-title i {\n  width: 20px;\n  text-align: center;\n  color: #999;\n}\n\n.language-item i {\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.language-item.active {\n  background: #f0f8ff;\n  color: #028661;\n  font-weight: 500;\n}\n\n.language-item.active i {\n  opacity: 1;\n  color: #028661;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .user-email {\n    display: none;\n  }\n\n  .header-right {\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
